import React from "react";

export default function ClassStatus(props) {
  function getShowTime() {
    var estimatedText = "";
    var time = props.related_data.actual_time;
    if (
      props.related_data.actual_time == "00:00:00" ||
      props.related_data.status != "Completed"
    ) {
      estimatedText = " (Estimated)";
      if (props.related_data.show_planned_time) {
        time =
          props.related_data.default_time != "00:00:00"
            ? format_time(props.related_data.default_time)
            : "";
      } else {
        time =
          props.related_data.estimated_time != "00:00:00"
            ? format_time(props.related_data.estimated_time)
            : "";
      }
    }
    var show_date = format_date(props.related_data.date);
    if (
      props.related_data.status != "Completed" &&
      (props.related_data.show_est_time ||
        props.related_data.show_planned_time) &&
      time != ""
    ) {
      return show_date + " at " + time + " " + estimatedText;
    }
    return show_date;
  }

  function format_time(timeString) {
    var H = +timeString.substr(0, 2);
    var h = H % 12 || 12;
    var ampm = H < 12 || H === 24 ? " AM" : " PM";
    timeString = h + timeString.substr(2, 3) + ampm;
    return timeString;
  }

  function format_date(unformatted_date) {
    var unformatted_date_split =
      unformatted_date && unformatted_date.split
        ? unformatted_date.split("T")[0]
        : unformatted_date;
    var formatted_date = new Date(unformatted_date_split);
    formatted_date = new Date(formatted_date.toISOString().slice(0, -1));
    var unformatted_month = formatted_date.getMonth() + 1;
    return (
      (unformatted_month < 10
        ? "0" + unformatted_month.toString()
        : unformatted_month.toString()) +
      "/" +
      (formatted_date.getDate() < 10
        ? "0" + formatted_date.getDate()
        : formatted_date.getDate()) +
      "/" +
      formatted_date.getFullYear()
    );
  }

  return (
    <div className='class-details, primary-header'>
      <p className='ring-name link_color'>{props.related_data.ring_name}</p>
      {props.related_data.show_ring_info && (
        <p className='aside schedule-date'>{getShowTime()}</p>
      )}

      <p className='oog-status'>
        {(props.callby == "division") ?
          (props.related_data.show_results) ? "" : props.class_details.oog_status_text
          :
          props.id === "Entries"
            ? props.class_details.oog_status_text
            : props.id === "Order"
              ? props.class_details.oog_status_text != "Order of Go not yet set"
                ? props.class_details.oog_status_text
                : ""
              : ""
        }

      </p>
      <p className='trips'>{props.related_data.unscratched_count} Trips </p>
      {props.related_data.show_ring_info && (
        <p className='class-status'>
          Status: {props.trips > 0 ? props.related_data.status : "Not Started"}
        </p>
      )}
    </div>
  );
}
